let booleanStatus = (status: boolean): { [key: string]: boolean } => {
    return {
        status: status,
    };
};

let workingHoursStatus = (workingHours: number): any => {
    return {
        status: workingHours,
    };
};

let workDayStatus = (workDays: number): any => {
    return {
        sunday: (workDays & 1) == 1,
        monday: (workDays & 2) == 2,
        tuesday: (workDays & 4) == 4,
        wednesday: (workDays & 8) == 8,
        thursday: (workDays & 16) == 16,
        friday: (workDays & 32) == 32,
        saturday: (workDays & 64) == 64,
    };
};

/**
 * Datapoint configurations.
 */
export default {
    WeekStartDay: {
        datapoint: {
            name: 'WeekStartDay',
            customData: (weekStartDay: number) => [weekStartDay],
        },
    },

    WeekStartDayQuick: {
        datapoint: {
            name: 'WeekStartDayQuick',
            customData: (weekStartDay: number) => [weekStartDay],
        },
    },

    TimeIncrement: {
        datapoint: {
            name: 'TimeIncrement',
            customData: (timeIncrement: number) => [timeIncrement],
        },
    },

    ShowWeekNumbers: {
        datapoint: {
            name: 'ShowWeekNumbers',
            customData: booleanStatus,
        },
    },

    FirstWeekOfYear: {
        datapoint: {
            name: 'FirstWeekOfYear',
            customData: (firstWeekOfYear: number) => [firstWeekOfYear],
        },
    },

    WorkingHoursStartTime: {
        datapoint: {
            name: 'WorkingHoursStartTime',
            customData: workingHoursStatus,
        },
    },

    WorkingHoursEndTime: {
        datapoint: {
            name: 'WorkingHoursEndTime',
            customData: workingHoursStatus,
        },
    },

    WorkDays: {
        datapoint: {
            name: 'WorkDays',
            customData: workDayStatus,
        },
    },
};
